import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flame } from 'lucide-react';

/**
 * The household streak — shared by everyone in the home, never by one person.
 *
 * It only ever counts up. One missed week is forgiven by the server, and there
 * is no "you lost it" state, no shame and no warning copy anywhere.
 */
export const StreakChip = ({ streak, testId = 'play-streak-chip' }) => {
    const { t } = useTranslation();
    if (!streak || !streak.enabled || !streak.weeks) return null;
    return (
        <div className="inline-flex items-center gap-2 rounded-full bg-[#F58220] px-3 py-1.5"
            data-testid={testId} title={t('play.streakHint')}>
            <Flame className="h-4 w-4 shrink-0 text-[#13265C]" />
            <span className="text-xs font-bold text-[#13265C]" data-testid={`${testId}-weeks`}>
                {t('play.streakWeeks', { count: streak.weeks })}
            </span>
        </div>
    );
};

export default StreakChip;
